import _has from 'lodash/has';

export const isTopicSaved = (savedTopics, topic) => {
  let id;
  if (_has(topic, 'id')) id = topic.id;
  else if (_has(topic, 'sys.id')) id = topic.sys.id;
  else if (_has(topic, 'objectID')) id = topic.objectID;
  return savedTopics && savedTopics.map(el => el.sys.id).includes(id);
};
